module.exports = __webpack_public_path__ + "img/circle_help_grey.b88ea3c4.png";